import { Injectable } from "@angular/core";

@Injectable()
export class LogService {
    // log(msg, color) {
    //     color = color || "black";
    //     const bgc = "White";
    //     switch (color) {
    //         case "success":  color = "Green";      bgc = "LimeGreen";       break;
    //         case "info":     color = "DodgerBlue"; bgc = "Turquoise";       break;
    //         case "error":    color = "Red";        bgc = "Black";           break;
    //         case "start":    color = "OliveDrab";  bgc = "PaleGreen";       break;
    //         case "warning":  color = "Tomato";     bgc = "Black";           break;
    //         case "end":      color = "Orchid";     bgc = "MediumVioletRed"; break;
    //         default: color = color;
    //     }
    
    //     if (typeof msg == "object") {
    //         console.log(msg);
    //     } else if (typeof color == "object") {
    //         console.log("%c" + msg, "color: PowderBlue;font-weight:bold; background-color: RoyalBlue;");
    //         console.log(color);
    //     } else {
    //         console.log("%c" + msg, "color:" + color + ";font-weight:bold; background-color: " + bgc + ";");
    //     }
    // }

    public static success(message: any, color: string = 'Green', bgc: string = 'LimeGreen') {
        if (typeof message == "object") {
            console.log(message);
            return;
        }

        console.log("%c" + message, "color:" + color + ";font-weight:bold; background-color: " + bgc + ";");
    }

    public static info(message: any, color: string = 'DodgerBlue', bgc: string = 'Turquoise') {
        if (typeof message == "object") {
            console.log(message);
            return;
        }

        console.log("%c" + message, "color:" + color + ";font-weight:bold; background-color: " + bgc + ";");
    }

    public static warning(message: any, color: string = 'Tomato', bgc: string = 'Black') {
        if (typeof message == "object") {
            console.log(message);
            return;
        }

        console.log("%c" + message, "color:" + color + ";font-weight:bold; background-color: " + bgc + ";");
    }

    public static error(message: any, color: string = 'Red', bgc: string = 'Black') {
        if (typeof message == "object") {
            console.log(message);
            return;
        }

        console.log("%c" + message, "color:" + color + ";font-weight:bold; background-color: " + bgc + ";");
    }
    
}